import type { ReactElement } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { TelegramIcon } from '@/assets/social/telegram';
import { MailIcon } from 'lucide-react';

export default function Social(): ReactElement {
  return (
    <div className="w-fit flex items-center justify-center gap-1.5 sm:gap-3">
      <Link href="mailto:mail@kilowattcoin.ru" target="_blank">
        <Button
          variant="secondary"
          className="w-32 flex items-center gap-1 sm:gap-1.5 border hover:bg-border/5"
        >
          <MailIcon className="w-5 h-5" />
          <p>Email</p>
        </Button>
      </Link>
      <Link href="https://t.me/KILOWATTCOIN" target="_blank">
        <Button
          variant="secondary"
          className="w-32 flex items-center gap-1 sm:gap-1.5 border hover:bg-border/5"
        >
          <TelegramIcon className="w-5 h-5" />
          <p>Telegram</p>
        </Button>
      </Link>
    </div>
  );
}
